import { render, staticRenderFns } from "./demandsList.vue?vue&type=template&id=e3840a3c&"
import script from "./demandsList.vue?vue&type=script&lang=js&"
export * from "./demandsList.vue?vue&type=script&lang=js&"
import style0 from "./demandsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports